import React from "react";
import axios from "axios";
import { URL, deviceID, App_Key, appSecret, Tenant_Id } from "./config";
import { Row, Col } from "antd";

class TermsAndConditions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      termsAndConditions: "",
    };
  }

  componentDidMount = () => {
    this.detailsOfTNC();
  };

  detailsOfTNC = () => {
    const md5 = require("md5");
    const uri = "api/mobile/getTNC";

    const now = new Date();
    const secondsSinceEpoch = Math.round(now.getTime() / 1000);

    const Request_Body = JSON.stringify({ deviceNo: deviceID });
    const sign = md5(
      App_Key + appSecret + uri + Request_Body + secondsSinceEpoch
    ).toString();

    const data = JSON.stringify({ deviceNo: `${deviceID}` });

    const config = {
      method: "post",
      url: `${URL}`.concat(`${uri}`),
      headers: {
        "Content-Type": "application/json",
        "Tenant-Id": `${Tenant_Id}`,
        time: `${secondsSinceEpoch}`,
        sign: `${sign}`,
        appkey: `${App_Key}`,
        "Serial-Number": `${deviceID}`,
        "Sale-Channel": "APP",
        "Update-Channel": "APP",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        // console.log("response========>>>>>>>>>", response);
        const termsAndConditions = response.data.data;
        this.setState({ termsAndConditions: termsAndConditions });
      })

      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const { termsAndConditions } = this.state;
    const intFrameHeight = window.innerHeight;
    return (
      <div
        style={{
          heigth: "100%",
          backgroundColor: "#fff",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          height: `${intFrameHeight}px`,
        }}
      >
        <Row
          style={{
            paddingTop: "40px",
            paddingLeft: "40px",
            paddingRight: "40px",
          }}
        >
          <Col span={24}>
            <b style={{ fontSize: "20px" }}>TERMS AND CONDITIONS</b>
          </Col>
        </Row>
        <div style={{ overflowY: "scroll", maxHeight: "500px" }}>
          <Row style={{ padding: "40px" }}>
            <Col span={24}>
              <text style={{ fontSize: "15px", whiteSpace: "break-spaces" }}>
                {termsAndConditions}
              </text>
            </Col>
          </Row>
        </div>
        <br />
      </div>
    );
  }
}

export default TermsAndConditions;
